module.exports = __webpack_public_path__ + "img/home-restaurant-01.5480c2cd.jpg";